import { Expose } from "class-transformer";
import { IsBoolean, IsNumber, IsString } from "class-validator";

export class UserOfficeProfile {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsString()
  name!: string;
  @Expose()
  @IsBoolean()
  isSelected!: boolean;
}
